module.exports = __webpack_public_path__ + "img/band_length.43168fa0.png";